/**
 * MEDIAPLEX 테마 관리 (Phase A Task 3)
 * - localStorage 'mpx-theme' 키로 저장
 * - document.documentElement 안 data-theme 속성 설정
 * - 기본값: 저장값 없으면 라이트 (D-1 라이트 기본 전환)
 *
 * AdminDashboard.jsx의 임시 다크 강제 setAttribute("data-theme","dark")
 * → unmount 시 prevTheme 복원. initTheme이 항상 attribute 설정하므로 호환.
 */

const STORAGE_KEY = "mpx-theme";
const THEMES = ["light", "dark"];

export function getStoredTheme() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (THEMES.includes(stored)) return stored;
  } catch {
    // localStorage 접근 불가 시 무시
  }
  return null;
}

export function getEffectiveTheme() {
  // 저장값 우선, 없으면 현재 DOM 속성, 그것도 없으면 light (D-1 기본)
  const stored = getStoredTheme();
  if (stored) return stored;
  const current =
    typeof document !== "undefined"
      ? document.documentElement.getAttribute("data-theme")
      : null;
  if (THEMES.includes(current)) return current;
  return "light";
}

export function applyTheme(theme) {
  if (!THEMES.includes(theme)) return;
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("data-theme", theme);
  }
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // 무시
  }
}

export function toggleTheme() {
  const current = getEffectiveTheme();
  const next = current === "light" ? "dark" : "light";
  applyTheme(next);
  return next;
}

// 앱 초기화 시 1회 호출.
// §1 잠금(테마 1개 라이트) — 토글 제거(2026-07-15 판정 ②)로 라이트 고정.
// 저장된 'dark'는 무시(토글 없던 시절 저장값에 갇힘 방지). 다크는 백로그 —
// toggleTheme/applyTheme는 보존, AdminDashboard 런타임 다크 강제(한시 예외)는 별도 경로.
export function initTheme() {
  applyTheme("light");
}
